"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CampusHours_component_1 = require("./CampusHours.component");
exports.AsherCampusHours = CampusHours_component_1.AsherCampusHours;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9DYW1wdXNIb3Vycy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlFQUF3RDtBQUFoRCxtREFBQSxnQkFBZ0IsQ0FBQSJ9